<template>
  <div class="no-contract-notice" v-if="!currentContractId">
    <p>Необходимо выбрать договор!</p>
    <SearchSelect
      class="no-contract-select"
      :options="contractOptionsForSelect"
      :initial="currentContractOption"
      label="name_contract"
      universal-mode
      :needles="['name_contract', 'N_contract', 'id_contract']"
      placeholder="Выбрать договор..."
      title-width="100%"
      @selectItem="selectContractFromDropdown"
    />
  </div>
  <div class="employees-lists" v-else>
    <a
      href="https://medsafe.pro/shablon_employee.xlsx"
      class="employees-lists__template-link">
      <mcw-button>
        <mcw-material-icon class="icon_base" icon="download"/>
        шаблон списки
      </mcw-button>
    </a>
    <a
      href="https://medsafe.pro/shablon_employee_contingent.xlsx"
      class="employees-lists__template-link">
      <mcw-button>
        <mcw-material-icon class="icon_base" icon="download"/>
        шаблон контингенты
      </mcw-button>
    </a>
    <mcw-button v-if="userRank >= 100">
      <mcw-material-icon class="icon_base" icon="upload"/>
      контингенты
      <input
        type="file"
        ref="file"
        accept=".xls, .xlsx"
        class="file-upload__input"
        v-on:change="handleFileUpload(2)"/>
    </mcw-button>
    <mcw-button v-if="userRank >= 100 && !showMOTypeSelector" @click.stop="showMOTypeSelector = true;">
      <mcw-material-icon class="icon_base" icon="upload"/>
      поименный список
    </mcw-button>
    <section v-if="showMOTypeSelector" style="display:flex;">
      <mcw-button @click.stop="showMOTypeSelector = false; selectedMOType = null;">
        <mcw-material-icon class="icon_base" icon="undo"/>
        Отмена
      </mcw-button>
      <mcw-select
        class="select_dense"
        v-model="selectedMOType"
        v-if="MOTypes.length"
        outlined
        label="Тип МО"
      >
        <mcw-list-item
          v-for="type of MOTypes"
          :key="type.id_reference"
          :data-value="type.id_reference"
          >{{ type.name_reference }}</mcw-list-item
        >
      </mcw-select>
      <mcw-button :disabled="!selectedMOType">
        <mcw-material-icon class="icon_base" icon="file_open"/>
        Выбрать файл
        <input
          type="file"
          ref="file"
          accept=".xls, .xlsx"
          class="file-upload__input"
          v-on:change="handleFileUpload(1)"
        />
      </mcw-button>
    </section>
    <mcw-data-table>
      <table class="mdc-data-table__table">
        <thead v-show="localItems.length">
          <tr class="mdc-data-table__header-row">
            <th>
            </th>
            <th class="mdc-data-table__header-cell">
              {{transcriptColumnTitle('list_name')}}
            </th>
            <th class="mdc-data-table__header-cell">
              {{transcriptColumnTitle('date_upload')}}
            </th>
            <th class="mdc-data-table__header-cell">
              {{transcriptColumnTitle('n_empl')}}
            </th>
            <th class="mdc-data-table__header-cell">
              {{transcriptColumnTitle('n_calc')}}
            </th>
            <th class="mdc-data-table__header-cell">
              {{transcriptColumnTitle('status_name')}}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody class="mdc-data-table__content">
          <tr class="mdc-data-table__row" v-if="!localItems.length">
            <td></td>
            <td class="mdc-data-table__cell" colspan="7">Нет загруженных документов</td>
          </tr>
          <tr
            class="mdc-data-table__row"
            v-for="(item, index) in localItems"
            :key="index"
            :value="item"
            @click="showStaff(item)">
            <td class="mdc-data-table__cell">
              <mcw-icon-button @click.stop="calculatePrice(item.id_list, item.id_contract)">
                <mcw-material-icon class="icon_base" icon="calculate"/>
              </mcw-icon-button>
            </td>
            <td class="mdc-data-table__cell">{{item.list_name}}</td>
            <td class="mdc-data-table__cell mdc-data-table__cell--numeric">{{item.date_upload}}</td>
            <td class="mdc-data-table__cell mdc-data-table__cell--numeric">{{item.n_empl}}</td>
            <td class="mdc-data-table__cell mdc-data-table__cell--numeric">{{item.n_calc}}</td>
            <td class="mdc-data-table__cell mdc-data-table__cell--numeric">{{item.status_name}}</td>
            <td class="mdc-data-table__cell">
              <mcw-button
                @click.stop="employeeToTree(item)"
              >
                В дерево
              </mcw-button>
              <mcw-button
                v-if="item.id_type === 1 && item.id_status === 1 && userRank >= 100"
                @click.stop="sendToWaiting(item)"
              >
                Отправить в ожидание
              </mcw-button>
              <mcw-button
                v-if="item.id_status !== 5 && userRank >= 100"
                @click.stop="employeeCancel(item)"
              >
                Отмена
              </mcw-button>
            </td>
          </tr>
        </tbody>
      </table>
    </mcw-data-table>
    <Teleport to="body">
      <transition name="validation-fade">
        <div
          v-if="validationErrors.length"
          class="validation-modal-overlay"
          @click.stop
          @mousedown.stop
        >
          <transition name="validation-slide-up">
            <div class="validation-modal" v-if="validationErrors.length">
              <div class="validation-header">
                <div class="validation-header-content">
                  <h3 class="validation-title">Некорректные пункты вредности в файле</h3>
                  <p class="validation-subtitle">
                    Загрузка отменена. Исправьте перечисленные значения в шаблоне и загрузите файл заново.<br />
                    Кнопка «Подобрать автоматически» подставит найденные варианты в пустые поля
                    <span class="validation-hint validation-hint--suggested">зелёным</span>, если код есть в справочнике,
                    <span class="validation-hint validation-hint--guessed">жёлтым</span>,
                    если это предположение и его стоит перепроверить. Поля можно править вручную.
                  </p>
                </div>
                <button @click="closeValidationErrors" class="validation-close-btn" type="button">
                  &times;
                </button>
              </div>

              <div class="validation-list">
                <table class="validation-table">
                  <thead>
                    <tr>
                      <th>Строка в Excel</th>
                      <th>№</th>
                      <th>Сотрудник / должность</th>
                      <th>Колонка</th>
                      <th>Значение</th>
                      <th>Исправление</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(err, index) in validationErrors" :key="index">
                      <td>{{ err.excelRow }}</td>
                      <td>{{ err.n }}</td>
                      <td>{{ err.position }}</td>
                      <td>{{ err.column }}</td>
                      <td><span class="validation-bad-value">{{ err.value }}</span></td>
                      <td>
                        <input
                          v-model="err.correction"
                          type="text"
                          class="validation-fix-input"
                          :class="{
                            'validation-fix-input--suggested': err.correction && err.correction === err.suggestionValue && !err.suggestionGuessed,
                            'validation-fix-input--guessed': err.correction && err.correction === err.suggestionValue && err.suggestionGuessed,
                          }"
                          :placeholder="err.value"
                          :title="err.correction && err.correction === err.suggestionValue ? (err.suggestionGuessed
                            ? 'Подобрано автоматически. Сверьте, опечатка могла быть определена неверно или подобран неверный код'
                            : 'Исправлено автоматически, код есть в справочнике') : ''"
                          @keyup.enter="applyCorrections"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="validation-actions">
                <button
                  @click="applySuggestions"
                  class="btn-suggest-validation"
                  type="button"
                  :disabled="!hasSuggestions"
                >
                  Подобрать автоматически
                </button>
                <button
                  @click="applyCorrections"
                  class="btn-confirm-warning"
                  type="button"
                  :disabled="!hasFilledCorrections"
                >
                  Применить исправления и проверить снова
                </button>
              </div>
            </div>
          </transition>
        </div>
      </transition>
    </Teleport>
    <Teleport to="body">
      <transition name="validation-fade">
        <div
          v-if="validationWarnings.length"
          class="validation-modal-overlay"
          @click.stop
          @mousedown.stop
        >
          <transition name="validation-slide-up">
            <div class="validation-modal" v-if="validationWarnings.length">
              <div class="validation-header validation-header--warning">
                <div class="validation-header-content">
                  <h3 class="validation-title validation-title--warning">Есть строки, требующие проверки</h3>
                  <p class="validation-subtitle">
                    Здесь нет ошибок формата, но действие требует подтверждения.<br />
                    Проверьте, что все пункты вредности корректны и соответствуют справочнику приказов.
                    При необходимости впишите верное значение в столбец «Исправление» — автоподбора здесь нет,
                    значение указывается вручную и будет использовано при загрузке.
                  </p>
                </div>
                <button @click="cancelUploadWithWarnings" class="validation-close-btn" type="button">
                  &times;
                </button>
              </div>

              <div class="validation-list">
                <table class="validation-table">
                  <thead>
                    <tr>
                      <th>Строка в Excel</th>
                      <th>№</th>
                      <th>Сотрудник / должность</th>
                      <th>Примечание</th>
                      <th>Исправление</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(warn, index) in validationWarnings" :key="index">
                      <td>{{ warn.excelRow }}</td>
                      <td>{{ warn.n }}</td>
                      <td>{{ warn.position }}</td>
                      <td>{{ warn.note }}</td>
                      <td>
                        <input
                          v-model="warn.correction"
                          type="text"
                          class="validation-fix-input"
                          placeholder="Ввести значение вручную"
                          @keyup.enter="proceedWithUpload"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="validation-actions">
                <button @click="cancelUploadWithWarnings" class="btn-close-validation" type="button">
                  Отмена
                </button>
                <button @click="proceedWithUpload" class="btn-confirm-warning" type="button">
                  {{ hasFilledWarningCorrections ? 'Применить исправления и загрузить' : 'Всё верно, загрузить' }}
                </button>
              </div>
            </div>
          </transition>
        </div>
      </transition>
    </Teleport>
    <section class="mdc-card confirm-card confirm-wrapper" v-if="showConfirm">
      <div class="mdc-card__primary-action">
        <h2 class="mdc-typography--headline6">Действие требует подтверждения</h2>
        <p class="mdc-typography--body2">Уверены, что все данные верны?</p>
      </div>

      <div class="mdc-card__actions mdc-card__actions--full-bleed">
        <div class="mdc-card__action-buttons">
          <button class="mdc-button mdc-card__action mdc-card__action--button" @click.stop="showConfirm = false;">
            <span class="mdc-button__label">Отмена</span>
          </button>
          <button class="mdc-button mdc-card__action mdc-card__action--button" @click.stop="confirmEmployeeToTree">
            <span class="mdc-button__label">В дерево</span>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { transcriptColumnTitle } from '@/helpers/transcriptor';
import { createJsonFromExcel } from '@/helpers/createJsonFromExcel';
import { mapState } from 'vuex';
import SearchSelect from './SearchSelect/SearchSelect.vue';

// Валидный код пункта приказа: цифры, при необходимости разделённые точками
// (23, 6.1, 4.2.3, 1.29.2). Точка в начале/конце или подряд идущие точки — брак в шаблоне.
const CODE_PATTERN = /^\d+(\.\d+)*$/;

// Справочник пунктов 29н приказа (legal_instrument 870), захардкожен по состоянию на 21.07.2026.
// Если справочник обновится на стороне заказчика раньше, чем здесь — код не найдётся,
// это не ошибка шаблона как таковая, поэтому такие случаи идут в предупреждения, а не в ошибки.
const VALID_CODES_870 = new Set([
  '1.1', '1.10', '1.11', '1.12', '1.13', '1.14', '1.14.1', '1.14.2', '1.15', '1.15.1',
  '1.16', '1.17', '1.18', '1.18.1', '1.18.2', '1.18.3', '1.19', '1.19.1', '1.19.2', '1.19.3',
  '1.2', '1.20', '1.21', '1.22', '1.23', '1.24', '1.25', '1.26', '1.27', '1.27.1',
  '1.27.2', '1.28', '1.29', '1.29.1', '1.29.2', '1.29.3', '1.29.4', '1.29.5', '1.30', '1.30.1',
  '1.31', '1.32', '1.33', '1.34', '1.34.1', '1.34.2', '1.35', '1.36', '1.36.1', '1.36.2',
  '1.36.3', '1.37', '1.37.1', '1.37.1.1', '1.37.1.2', '1.37.2', '1.38', '1.39', '1.4', '1.40',
  '1.40.1', '1.40.2', '1.41', '1.42', '1.43', '1.43.1', '1.43.2', '1.44', '1.45', '1.45.1',
  '1.45.2', '1.45.3', '1.46', '1.47', '1.47.1', '1.47.10', '1.47.11', '1.47.12', '1.47.13', '1.47.14',
  '1.47.15', '1.47.16', '1.47.2', '1.47.3', '1.47.4', '1.47.5', '1.47.6', '1.47.7', '1.47.8', '1.47.9',
  '1.48', '1.49', '1.49.1', '1.49.10', '1.49.11', '1.49.12', '1.49.13', '1.49.14', '1.49.2', '1.49.3',
  '1.49.4', '1.49.5', '1.49.6', '1.49.7', '1.49.8', '1.49.9', '1.5', '1.5.1', '1.50', '1.51',
  '1.51.1', '1.51.2', '1.52', '1.52.1', '1.52.2', '1.52.3', '1.52.4', '1.52.5', '1.52.6', '1.52.7',
  '1.53', '1.53.1', '1.53.2', '1.6', '1.7', '1.7.1', '1.7.2', '1.8', '1.8.1', '1.8.1.1',
  '1.8.1.2', '1.8.2', '1.8.2.1', '1.8.2.2', '1.8.3', '1.8.3.1', '1.8.3.2', '1.8.4', '1.8.4.1', '1.8.4.2',
  '1.9', '10', '11', '11.1', '11.2', '11.3', '11.4', '12', '13', '14',
  '15', '16', '17', '18', '18.1', '18.2', '19', '19.1', '19.2', '19.3',
  '2.1', '2.2', '2.3', '2.4', '2.4.1', '2.4.2', '2.4.3', '2.4.4', '2.4.5', '20',
  '21', '22', '23', '24', '25', '26', '27', '3.1', '3.1.1', '3.1.10',
  '3.1.2', '3.1.3', '3.1.4', '3.1.5', '3.1.6', '3.1.7', '3.1.8', '3.1.8.1', '3.1.8.2', '3.1.8.3',
  '3.1.9', '3.1.9.1', '3.1.9.2', '3.1.9.3', '3.1.9.4', '3.2', '3.3', '3.4', '4.1', '4.10',
  '4.2', '4.2.1', '4.2.2', '4.2.3', '4.2.4', '4.2.5', '4.3', '4.3.1', '4.3.2', '4.4',
  '4.5', '4.6', '4.7', '4.8', '4.9', '5.1', '5.2', '5.2.1', '5.2.2', '6',
  '6.1', '6.2', '7', '7.2.4', '8', '9',
]);

// Справочник пунктов 342н приказа / ОПО (legal_instrument 871) — плоские номера 1-17, без точек.
const VALID_CODES_871 = new Set([
  '1', '10', '11', '12', '13', '14', '15', '16', '17', '2',
  '3', '4', '5', '6', '7', '8', '9',
]);
// Колонки с кодами пунктов приказа — свои для каждого шаблона загрузки (param):
// 2 — контингент: F "Пункты 29н приказа" (ключ 6), M "Пункты приказа 342н" (ключ 13)
// 1 — поименный список: K "Пункты 29н приказа" (ключ 11), AH "Пункты приказа 342н" (ключ 34)
const HAZARD_COLUMNS_BY_PARAM = {
  2: { 6: 'Пункты 29н приказа', 13: 'Пункты приказа 342н' },
  1: { 11: 'Пункты 29н приказа', 34: 'Пункты приказа 342н' },
};
const VALID_CODES_BY_PARAM_COLUMN = {
  2: { 6: VALID_CODES_870, 13: VALID_CODES_871 },
  1: { 11: VALID_CODES_870, 34: VALID_CODES_871 },
};
// Основная колонка "Пункты 29н приказа" по шаблону — по ней проверяем пустоту (предупреждение).
const MAIN_HAZARD_COLUMN_BY_PARAM = { 2: '6', 1: '11' };

// Чинит типичные опечатки в коде пункта: "п." / "пункт" перед числом, запятая
// вместо точки, лишние пробелы, задвоенные или краевые точки ("п.9" -> "9", ".6.1" -> "6.1").
function normalizeCandidateCode(rawValue) {
  return String(rawValue)
    .trim()
    .replace(/^п(ункт)?\.?\s*/i, '')
    .replace(/,/g, '.')
    .replace(/\s+/g, '')
    .replace(/\.{2,}/g, '.')
    .replace(/^\.+|\.+$/g, '');
}

// Расстояние Левенштейна — для поиска ближайшего кода в справочнике, если
// нормализация по правилам не дала код нужного формата.
function levenshteinDistance(a, b) {
  const rows = a.length + 1;
  const cols = b.length + 1;
  const dp = Array.from({ length: rows }, () => new Array(cols).fill(0));
  for (let i = 0; i < rows; i += 1) dp[i][0] = i;
  for (let j = 0; j < cols; j += 1) dp[0][j] = j;
  for (let i = 1; i < rows; i += 1) {
    for (let j = 1; j < cols; j += 1) {
      dp[i][j] = a[i - 1] === b[j - 1]
        ? dp[i - 1][j - 1]
        : 1 + Math.min(dp[i - 1][j - 1], dp[i - 1][j], dp[i][j - 1]);
    }
  }
  return dp[rows - 1][cols - 1];
}

// Пытается предположить правильный код для найденной ошибки:
// 1) чинит опечатку по правилам (см. normalizeCandidateCode);
//    если результат нужного формата и есть в справочнике этой колонки — уверенная подсказка;
//    если формат верный, но код не найден в справочнике — тоже подсказываем, но как "проверьте";
// 2) если по правилам не собралось — ищем ближайший код в справочнике (расстояние Левенштейна <= 1)
//    и тоже подсказываем как "проверьте", раз это уже подбор, а не точное исправление формата.
// Возвращает null, если предположить нечего — тогда поле исправления остаётся пустым.
function suggestCodeCorrection(rawValue, validCodes) {
  const normalized = normalizeCandidateCode(rawValue);
  if (CODE_PATTERN.test(normalized) && normalized !== '') {
    return { value: normalized, guessed: !validCodes.has(normalized) };
  }
  let best = null;
  let bestDist = Infinity;
  validCodes.forEach((code) => {
    const dist = levenshteinDistance(normalized, code);
    if (dist < bestDist) {
      bestDist = dist;
      best = code;
    }
  });
  if (best !== null && bestDist <= 1) {
    return { value: best, guessed: true };
  }
  return null;
}

export default {
  name: 'EmployeesLists',
  components: {
    SearchSelect,
  },
  props: {
    items: Array,
  },
  emits: [
    'showStaff',
    'close',
    'uploadList',
    'contract-selected',
  ],
  data() {
    return {
      localItems: [],
      json: null,
      param: null,
      showConfirm: false,
      selectedList: null,
      showMOTypeSelector: false,
      selectedMOType: null,
      validationErrors: [],
      validationWarnings: [],
    };
  },
  computed: {
    userRank() {
      return this.$store.getters['user/getUserRank'];
    },
    currentContractId() {
      return this.$store.getters['contractsData/getCurrentContract'] || 0;
    },
    hasBlockingModal() {
      return this.validationErrors.length > 0 || this.validationWarnings.length > 0;
    },
    hasFilledCorrections() {
      return this.validationErrors.some((err) => (err.correction || '').trim() !== '');
    },
    hasSuggestions() {
      return this.validationErrors.some((err) => !!err.suggestionValue);
    },
    hasFilledWarningCorrections() {
      return this.validationWarnings.some((warn) => (warn.correction || '').trim() !== '');
    },
    contractOptionsForSelect() {
      return this.contracts
        .filter((c) => Number(c.id_contract) !== 0)
        .map((c) => ({
          ...c,
          name_contract: `${c.id_contract} | ${c.name_contract}`,
        }));
    },
    currentContractOption() {
      return this.contractOptionsForSelect.find(
        (c) => String(c.id_contract) === String(this.currentContract),
      ) || {};
    },
    ...mapState({
      MOTypes: (state) => state.treeData.MOTypes,
      contracts: (state) => state.contractsData.contracts,
      currentContract: (state) => state.contractsData.currentContract,
    }),
  },
  created() {
    this.localItems = this.items.slice();
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscape);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleEscape);
    document.body.style.overflow = '';
  },
  watch: {
    hasBlockingModal(newVal) {
      document.body.style.overflow = newVal ? 'hidden' : '';
    },

    items(newItems) {
      this.localItems = (newItems || []).slice();
    },

    currentContractId(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.$store.dispatch('employeesData/getDocList');
        this.$emit('contract-selected', newVal);
      }
    },
  },
  methods: {
    async selectContractFromDropdown(option) {
      if (!option || !option.id_contract) return;

      const id = `${option.id_contract}`;

      if (this.currentContract === id) {
        this.$store.commit('contractsData/SET_CURRENT_CONTRACT', '');
        this.$store.commit('contractsData/RESET_CONTRACT_DATA');
        await this.$store.dispatch('employeesData/getLastPatients', { includeServices: false });
        return;
      }

      this.$store.commit('contractsData/SET_CURRENT_CONTRACT', id);
      await this.$store.dispatch('contractsData/getConclusions', id);
    },
    handleEscape(e) {
      if (e.key !== 'Escape') return;
      if (this.validationErrors.length) {
        this.closeValidationErrors();
      } else if (this.validationWarnings.length) {
        this.cancelUploadWithWarnings();
      }
    },
    showStaff(param) {
      this.$emit('showStaff', param);
    },
    async calculatePrice(idList, idContract) {
      const result = await this.$store.dispatch('employeesData/priceCalculation', { idList, idContract });
      if (result) {
        this.localItems.find((item) => item.id_list === idList).n_calc += 1;
        this.emitter.emit('message', 'Калькуляция рассчитана');
        this.$store.dispatch('employeesData/getDocList');
      } else {
        this.emitter.emit('message', 'Не удалось рассчитать калькуляцию');
      }
    },
    transcriptColumnTitle(column) {
      return transcriptColumnTitle(column);
    },
    closeValidationErrors() {
      this.validationErrors = [];
    },

    rowLabel(row, param) {
      if (param === 2) {
        return row['5']; // Должность
      }
      const fio = [row['2'], row['3'], row['4']]
        .filter((v) => v !== null && v !== undefined && String(v).trim() !== '')
        .join(' ');
      const position = row['10'];
      return [fio, position].filter(Boolean).join(' — ');
    },
    validateContingentCodes(json, param) {
      const errors = [];
      const warnings = [];
      const hazardColumns = HAZARD_COLUMNS_BY_PARAM[param];
      if (!hazardColumns) return { errors, warnings }; // неизвестный шаблон — нет разметки колонок
      const validCodesByColumn = VALID_CODES_BY_PARAM_COLUMN[param];
      const mainColKey = MAIN_HAZARD_COLUMN_BY_PARAM[param];

      json.forEach((row) => {
        const mainRaw = row[mainColKey];
        if (mainRaw === null || mainRaw === undefined || String(mainRaw).trim() === '') {
          warnings.push({
            n: row['1'],
            excelRow: row.__excelRow,
            position: this.rowLabel(row, param),
            note: 'Не указано ни одного пункта приказа 29н',
            row,
            colKey: mainColKey,
            correction: '',
          });
        }
        Object.keys(hazardColumns).forEach((colKey) => {
          const raw = row[colKey];
          if (raw === null || raw === undefined || raw === '') return;
          const validCodes = validCodesByColumn[colKey];
          String(raw)
            .split(/[;,]/)
            .map((code) => code.trim())
            .filter((code) => code !== '')
            .forEach((code, codeIndex) => {
              if (!CODE_PATTERN.test(code)) {
                const suggestion = suggestCodeCorrection(code, validCodes);
                errors.push({
                  n: row['1'],
                  excelRow: row.__excelRow,
                  position: this.rowLabel(row, param),
                  column: hazardColumns[colKey],
                  value: code,
                  row,
                  colKey,
                  codeIndex,
                  correction: '',
                  suggestionValue: suggestion ? suggestion.value : null,
                  suggestionGuessed: !!(suggestion && suggestion.guessed),
                });
                return;
              }
              if (!validCodes.has(code)) {
                warnings.push({
                  n: row['1'],
                  excelRow: row.__excelRow,
                  position: this.rowLabel(row, param),
                  note: `Код «${code}» (${hazardColumns[colKey]}) не найден в справочнике — сверьте вручную`,
                  row,
                  colKey,
                  codeIndex,
                  correction: '',
                });
              }
            });
        });
      });
      return { errors, warnings };
    },
    buildUploadContext() {
      const context = {
        json: this.json,
        param: this.param,
      };
      if (this.param === 1) {
        context.osmotr_type = this.selectedMOType;
      }
      return context;
    },
    proceedWithUpload() {
      this.applyWarningCorrections();
      this.validationWarnings = [];
      this.$emit('uploadList', this.buildUploadContext());
    },
    cancelUploadWithWarnings() {
      this.validationWarnings = [];
      if (this.$refs.file) this.$refs.file.value = '';
    },
    // Переносит вручную введённые исправления (без автоподбора) из таблицы предупреждений
    // прямо в загруженный json перед отправкой — по ссылке на строку/колонку и, если это
    // конкретный код внутри списка через ";", по его индексу. Для предупреждения о полностью
    // пустой колонке (codeIndex не задан) значение колонки просто заменяется целиком.
    applyWarningCorrections() {
      const groups = new Map(); // row -> Map(colKey -> Map(indexKey -> correction))
      const FULL = Symbol('full-column');

      this.validationWarnings.forEach((warn) => {
        const correction = (warn.correction || '').trim();
        if (!correction || !warn.row || warn.colKey === undefined) return;
        if (!groups.has(warn.row)) groups.set(warn.row, new Map());
        const colMap = groups.get(warn.row);
        if (!colMap.has(warn.colKey)) colMap.set(warn.colKey, new Map());
        const indexKey = warn.codeIndex === undefined || warn.codeIndex === null ? FULL : warn.codeIndex;
        colMap.get(warn.colKey).set(indexKey, correction);
      });

      groups.forEach((colMap, row) => {
        colMap.forEach((indexMap, colKey) => {
          if (indexMap.has(FULL)) {
            row[colKey] = indexMap.get(FULL);
            return;
          }
          const codes = String(row[colKey] || '')
            .split(/[;,]/)
            .map((code) => code.trim())
            .filter((code) => code !== '');
          const rebuilt = codes.flatMap((code, codeIndex) => {
            if (!indexMap.has(codeIndex)) return [code];
            return indexMap.get(codeIndex)
              .split(/[;,]/)
              .map((c) => c.trim())
              .filter((c) => c !== '');
          });
          row[colKey] = rebuilt.join('; ');
        });
      });
    },
    async handleFileUpload(param) {
      this.json = await createJsonFromExcel(this.$refs.file.files[0]);
      if (this.json.length && this.json[0]['1'].toString().includes('№')) {
        this.json.shift(); // шапка вырезается, если находится
      }
      this.param = param;
      const { errors, warnings } = this.validateContingentCodes(this.json, param);
      this.applyValidationResult(errors, warnings, { resetFileInput: true });
    },
    // Общая ветка "ошибки / предупреждения / всё ок" — используется и при первой
    // загрузке файла, и при повторной проверке после ручных исправлений в таблице ошибок.
    applyValidationResult(errors, warnings, { resetFileInput = false } = {}) {
      if (errors.length) {
        this.validationErrors = errors;
        this.emitter.emit('message', `Найдено некорректных пунктов вредности: ${errors.length}. Исправьте шаблон и загрузите заново`);
        if (resetFileInput && this.$refs.file) this.$refs.file.value = '';
        return;
      }
      this.validationErrors = [];
      if (warnings.length) {
        this.validationWarnings = warnings;
        return;
      }
      this.validationWarnings = [];
      this.$emit('uploadList', this.buildUploadContext());
    },
    // Подставляет подобранные исправления в ещё не заполненные вручную поля.
    // Ничего не делает автоматически при открытии модалки — только по нажатию кнопки.
    applySuggestions() {
      let filled = 0;
      this.validationErrors.forEach((err) => {
        if (err.suggestionValue && !(err.correction || '').trim()) {
          err.correction = err.suggestionValue;
          filled += 1;
        }
      });
      if (!filled) {
        this.emitter.emit('message', 'Нет новых подсказок для незаполненных полей');
      }
    },
    // Применяет введённые в таблице ошибок исправления прямо к загруженному json
    // (по ссылке на строку/колонку/индекс кода внутри ячейки) и запускает валидацию заново.
    applyCorrections() {
      const groups = new Map(); // row -> Map(colKey -> Map(codeIndex -> correction))
      let filledCount = 0;

      this.validationErrors.forEach((err) => {
        const correction = (err.correction || '').trim();
        if (!correction || !err.row || err.colKey === undefined || err.codeIndex === undefined) return;
        filledCount += 1;
        if (!groups.has(err.row)) groups.set(err.row, new Map());
        const colMap = groups.get(err.row);
        if (!colMap.has(err.colKey)) colMap.set(err.colKey, new Map());
        colMap.get(err.colKey).set(err.codeIndex, correction);
      });

      if (!filledCount) {
        this.emitter.emit('message', 'Заполните хотя бы одно поле исправления');
        return;
      }

      groups.forEach((colMap, row) => {
        colMap.forEach((indexMap, colKey) => {
          const codes = String(row[colKey])
            .split(/[;,]/)
            .map((code) => code.trim())
            .filter((code) => code !== '');
          const rebuilt = codes.flatMap((code, codeIndex) => {
            if (!indexMap.has(codeIndex)) return [code];
            return indexMap.get(codeIndex)
              .split(/[;,]/)
              .map((c) => c.trim())
              .filter((c) => c !== '');
          });
          row[colKey] = rebuilt.join('; ');
        });
      });

      const { errors, warnings } = this.validateContingentCodes(this.json, this.param);
      this.applyValidationResult(errors, warnings);
    },
    async employeeCancel(item) {
      const params = {
        id_contract: item.id_contract,
        json_param: JSON.stringify({ id_list: item.id_list }),
      };
      const result = await this.$store.dispatch('employeesData/cancelEmployeeList', params);
      if (!result) {
        this.emitter.emit('message', 'Не удалось удалить список');
      }
    },
    close() {
      this.$emit('close');
    },
    employeeToTree(item) {
      this.selectedList = item;
      this.showConfirm = true;
    },
    async confirmEmployeeToTree() {
      if (!this.selectedList) return;
      this.showConfirm = false;
      const params = {
        id_contract: this.selectedList.id_contract,
        json_param: JSON.stringify({
          id_list: this.selectedList.id_list,
          id_parent: '',
          override: 0,
        }),
      };
      const result = await this.$store.dispatch('employeesData/employeeToTree', params);
      if (result) {
        if (result.err_text) {
          this.emitter.emit('message', result.err_text);
        }
        this.close();
      } else {
        this.emitter.emit('message', 'Не удалось создать дерево');
      }
    },
    async sendToWaiting(item) {
      const params = {
        id_contract: item.id_contract,
        json_param: JSON.stringify({ id_list: item.id_list }),
      };
      const result = await this.$store.dispatch('employeesData/checkEmployeeToPatient', params);
      if (result && result.err_text) {
        this.emitter.emit('message', result.err_text);
      }
      if (!result) {
        this.emitter.emit('message', 'Не удалось отправить список');
      }
    },
  },
};
</script>

<style scoped>
.no-contract-notice {
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 100%;
}

.no-contract-notice:focus-within {
  width: 450px;
  height: 300px;
  max-width: 450px;
}
.no-contract-select {
  width: 100%;
  min-width: 280px;
}
.employees-lists{
  padding: 10px;
}
.employees-lists__template-link{
  text-decoration: none;
}
.mdc-data-table__row{
  cursor: pointer;
}
.confirm-wrapper {
  z-index: 10000;
  position: absolute;
  left: 0;
  top: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
  text-align: center;
}

.validation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  padding: 20px;
}

.validation-modal {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 720px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.validation-fade-enter-active, .validation-fade-leave-active {
  transition: opacity 0.3s;
}
.validation-fade-enter, .validation-fade-leave-to {
  opacity: 0;
}

.validation-slide-up-enter-active {
  animation: validationSlideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}
.validation-slide-up-leave-active {
  animation: validationSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1) reverse;
}
@keyframes validationSlideUp {
  from {
    opacity: 0;
    transform: translateY(50px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.validation-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  border-bottom: 1px solid #eaeaea;
  background: #fff5f5;
  flex-shrink: 0;
}
.validation-header-content {
  flex: 1;
}
.validation-title {
  margin: 0 0 5px 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #c0392b;
}
.validation-subtitle {
  margin: 0;
  font-size: 0.9rem;
  color: #666;
}
.validation-close-btn {
  background: none;
  border: none;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  line-height: 30px;
  transition: color 0.2s;
}
.validation-close-btn:hover {
  color: #333;
}

.validation-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 20px;
}
.validation-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}
.validation-table th,
.validation-table td {
  text-align: left;
  padding: 10px 8px;
  border-bottom: 1px solid #f0f0f0;
}
.validation-table thead th {
  position: sticky;
  top: 0;
  background: #fff;
  color: #666;
  font-weight: 600;
  box-shadow: 0 1px 0 #eaeaea;
}
.validation-bad-value {
  display: inline-block;
  font-family: monospace;
  background: #fdecea;
  color: #c0392b;
  padding: 2px 6px;
  border-radius: 4px;
}
.validation-fix-input {
  width: 100%;
  min-width: 90px;
  box-sizing: border-box;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.9rem;
}
.validation-fix-input:focus {
  outline: none;
  border-color: #27ae60;
  box-shadow: 0 0 0 2px rgba(39, 174, 96, 0.15);
}
.validation-fix-input--suggested {
  border-color: #27ae60;
  background: #f0faf3;
}
.validation-fix-input--guessed {
  border-color: #d4a017;
  background: #fffaea;
}
.validation-hint {
  font-weight: 600;
}
.validation-hint--suggested {
  color: #27ae60;
}
.validation-hint--guessed {
  color: #b7791f;
}

.validation-header--warning {
  background: #fffbea;
}
.validation-title--warning {
  color: #b7791f;
}

.validation-actions {
  border-top: 1px solid #eaeaea;
  padding: 16px 20px;
  background: #f8f9fa;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  flex-shrink: 0;
}
.btn-close-validation {
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  background: #6c757d;
  color: #fff;
  transition: all 0.3s;
}
.btn-close-validation:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

.btn-suggest-validation {
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid #2f80ed;
  background: #fff;
  color: #2f80ed;
  transition: all 0.3s;
}
.btn-suggest-validation:hover {
  background: #eaf2fe;
}
.btn-suggest-validation:disabled {
  border-color: #c7c7c7;
  color: #a0a0a0;
  cursor: not-allowed;
  background: #fff;
}

.btn-confirm-warning {
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  background: #27ae60;
  color: #fff;
  transition: all 0.3s;
}
.btn-confirm-warning:hover {
  background: #219150;
  transform: translateY(-1px);
}
.btn-confirm-warning:disabled {
  background: #a8d5bb;
  cursor: not-allowed;
  transform: none;
}

.validation-list::-webkit-scrollbar {
  width: 6px;
}
.validation-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.validation-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.validation-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
